import { Button, Checkbox, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CreateProfileCardWrapper from "../../components/common/CreateProfileCardWrapper";
import { setInfoContent } from "../../redux/slices/common_slice";
import { handleKeyDown } from "../../utils/helper";
import "./OnboardingPage.css";

const HouseholdPage = ({ formik, handleEditableStep, editableStep }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleOptionChange = (option) => {
    const houseHoldArr = [...formik.values?.houseHold];
    const foundIndex = houseHoldArr?.findIndex((i) => i.type === option);
    if (
      (option === "otherMembers" || option === "children") &&
      foundIndex === -1
    ) {
      handleEditableStep(6);
      houseHoldArr.push({ type: option, count: "" });
    } else if (foundIndex === -1) {
      houseHoldArr.push({ type: option });
    } else {
      const filteredArr = houseHoldArr.filter((i) => i.type != option);
      formik.setFieldValue("houseHold", filteredArr);
      return;
    }
    formik.setFieldValue("houseHold", houseHoldArr);
  };
  const handleNumberInputChange = (e, type) => {
    const houseHoldArr = [...formik.values?.houseHold];
    const foundIndex = houseHoldArr.findIndex((i) => i.type === type);
    houseHoldArr[foundIndex] = {
      ...houseHoldArr[foundIndex],
      count: e.target.value,
    };
    formik.setFieldValue("houseHold", houseHoldArr);
    formik.setFieldValue(type, e.target.value);
  };
  const arr = [
    {
      label: t("aboutYou.ques8.options.1"),
      value: "myself",
    },
    {
      label: t("aboutYou.ques8.options.2"),
      value: "partner",
    },
    {
      label: t("aboutYou.ques8.options.3"),
      value: "children",
    },
    {
      label: t("aboutYou.ques8.options.4"),
      value: "otherMembers",
    },
  ];
  return (
    <CreateProfileCardWrapper>
      <h5 className="d-flex align-items-center justify-content-between">
        {t("aboutYou.ques8.title")}
        <Button
          className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 info-icon-btn"
          onClick={() => {
            dispatch(setInfoContent(t("aboutYou.resources.4")));
          }}
        >
          <img
            src="/assets/images/icons/info-circle-icon.svg"
            alt=""
            className="img-fluid"
          />
        </Button>
      </h5>
      <p>{t("aboutYou.ques8.helperText")}</p>
      <div className="household-options">
        <div className="common-checkbox-with-child">
          {arr.map((option) => {
            let foundItem = formik.values?.houseHold?.find(
              (i) => i?.type === option?.value
            );
            return (
              <div
                className="w-100 parent-child-group-div position-relative"
                key={option?.value}
              >
                <div className="radio-with-button">
                  <Checkbox
                    value={option?.value}
                    checked={
                      option?.value === "myself"
                        ? true
                        : option?.value === foundItem?.type
                    }
                    onChange={() => handleOptionChange(option?.value)}
                    disabled={option?.value === "myself"}
                  >
                    {option.label}
                    {option.value === "children" ||
                    option.value === "otherMembers" ? (
                      foundItem?.count && !editableStep ? (
                        <span
                          style={{
                            color: "#bdbdbd",
                            marginLeft: "5px",
                            marginTop: "4px",
                          }}
                        >
                          {foundItem?.count}
                        </span>
                      ) : (
                        t("aboutYou.ques8.options.howMany")
                      )
                    ) : (
                      ""
                    )}
                  </Checkbox>
                  {(option.value === "children" ||
                    option.value === "otherMembers") && (
                    <Button
                      icon={
                        (option.value === "children" &&
                          foundItem?.type === "children") ||
                        (option.value === "otherMembers" &&
                          foundItem?.type === "otherMembers") ? (
                          <img alt="" src={"/assets/images/icons/minus.svg"} />
                        ) : (
                          <img alt="" src={"/assets/images/icons/plus.svg"} />
                        )
                      }
                      onClick={() => handleOptionChange(option?.value)}
                    />
                  )}
                </div>
                {foundItem &&
                  editableStep &&
                  ((option.value === "children" &&
                    foundItem?.type === "children") ||
                    (option.value === "otherMembers" &&
                      foundItem?.type === "otherMembers")) && (
                    <Input
                      className="manual-input"
                      placeholder={
                        option.value === "otherMembers"
                          ? t("aboutYou.ques8.options.4placeholder")
                          : t("aboutYou.ques8.options.3placeholder")
                      }
                      onChange={(e) =>
                        handleNumberInputChange(e, foundItem?.type)
                      }
                      onKeyDown={handleKeyDown}
                      onBlur={formik.handleBlur}
                      name={option?.value}
                      value={foundItem?.count}
                      style={{
                        marginTop: "15px",
                        paddingLeft: "20px",
                        pointerEvents: "all",
                      }}
                    />
                  )}
                {formik.touched[option?.value] &&
                formik.errors[option?.value] ? (
                  <div className="error-message">{formik.errors[option]}</div>
                ) : null}
              </div>
            );
          })}
          {formik.touched?.houseHold && formik.errors?.houseHold ? (
            <div className="error-message">{formik.errors?.houseHold}</div>
          ) : null}
        </div>
      </div>
    </CreateProfileCardWrapper>
  );
};

export default HouseholdPage;
